module.exports = __webpack_public_path__ + "69bde2da7f69ebf64e3cbe667da76f39.svg";